import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@/api/ajax';

export interface PartReq {
  /**
   * 备件编码
   */
  partNo?: string;
}

export interface PartSpecialRemarkResp {
  /**
   * 特别信息-富文本
   */
  content?: string;
}

/**
 * @operationId partSpecialRemarkUsingPOST
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/partSpecialRemarkUsingPOST
 */
export function partSpecialRemarkUsingPost(
  data: PartReq
): XDragonApiResponsePromise<PartSpecialRemarkResp> {
  return ajax({
    url: '/api/tis/web/epc/catalog/part/specialRemark',
    method: 'post',
    data: data
  });
}
